import { Box, Card, CardContent } from "@material-ui/core"
import type { ReactElement, ReactNode } from "react"

import "./card-template.styles.scss"

export interface ICardTemplateProps {
  big?: boolean | undefined
  className?: string
  header?: ReactNode
  image?: ReactNode
  selected?: boolean
  children?: ReactNode
  onClick?: () => void
  "data-testid"?: string
}

export function CardTemplate(props: ICardTemplateProps): ReactElement {
  const { big, className, header, image, selected, children, onClick, "data-testid": dataTestId } = props

  return (
    <Card
      elevation={0}
      className={`card-template ${selected && "selected"} ${className || ""}`}
      data-mdat="referrer"
      data-mdat-item-id="card"
      tabIndex={0}
      data-testid={dataTestId}
    >
      {onClick ? (
        <Box onClick={onClick} className="card-template-button" data-mdat-item-id="card">
          <Box className="card-template-header" data-mdat-item-id="card-header">
            {header}
          </Box>
          <Box className={`card-template-image ${big ? "large" : ""}`} data-mdat-item-id="card-image">
            {image}
          </Box>
          <CardContent className="card-template-content" data-mdat-item-id="card-content">
            {children}
          </CardContent>
        </Box>
      ) : (
        <Box className="card-template-button">
          <Box className="card-template-header">{header}</Box>
          <Box className={`card-template-image ${big ? "large" : ""}`}>{image}</Box>
          <CardContent className="card-template-content">{children}</CardContent>
        </Box>
      )}
    </Card>
  )
}
